import config from "../app.json";


import "./Styles/eventlog-card.scss";
import React from "react";
import { Row, Col } from "react-bootstrap";
import Image from "./Image/image";
import EventlogCardStatus from "./EventlogCardStatus";
import accountIcon from "../Assets/Images/account.png";

function EventlogCard(props) {
  const { name, eventName, time } = props;

  return (
    <Row className="eventlog-card-row">
      <Col className="col-md-2">
        <Image style={{ backgroundColor: '#888' }} radius={16} src={props.userPictureGuid ? config.API + "/api/file/download/?guid=" + props.userPictureGuid : null} alt="alt" width={48} height={48} />
      </Col>
      <Col className="col-md-7">
        <div className="user-name-log">{props.userName}</div>
        <div className="log-message">{props.message}</div>
      </Col>
      <Col className="col-md-3">
        <EventlogCardStatus {...props} />
      </Col>
    </Row>
  );
}

export default EventlogCard;
